import { ReactComponent as SvgFacebook } from "assets/facebook.svg";
import { ReactComponent as SvgTwitter } from "assets/twitter.svg";
import NameLogo from "components/NameLogo";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

const FooterWrapper = styled.div`
  display: grid;
  grid-template:
    "col1 col2"
    "col3 col4"
    "logo logo" / 1fr 1fr;
  padding: 60px 30px 200px;
  grid-column-gap: 10px;
  grid-row-gap: 60px;

  ${mediaMin.xs`
    grid-template:
      "col1 col2 col3 col4"
      "logo logo logo logo" / 1fr 1fr 1fr 1fr;
    padding: 120px 60px;
    grid-row-gap: 70px;
  `};

  ${mediaMin.md`
    grid-template:
      "logo col1 col2 col3 col4" / 2fr 1fr 1fr 1fr 130px;
  `};
`;

const Col1 = styled.div`
  grid-area: col1;
`;
const Col2 = styled.div`
  grid-area: col2;
`;
const Col3 = styled.div`
  grid-area: col3;
`;
const Col4 = styled.div`
  grid-area: col4;
`;

const Logo = styled.div`
  grid-area: logo;
`;

const ColumnTitle = styled.h3`
  margin: 0;
  font-size: 17px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.white};
`;

const ColumnContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 32px;
`;

const ColumnContentLink = styled(Link)`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.white};
`;

const SNSIconsWrapper = styled.div`
  display: flex;
  color: ${({ theme }) => theme.palette.white};
  gap: 12px;
  svg {
    width: 20px;
    height: 20px;
  }
`;

const LogoWrapper = styled.div``;

const CopyrightText = styled.p`
  margin-top: 16px;
  font-size: 14px;
  line-height: 150%;
`;

const FooterLink = styled.a`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.white};
`;

export function Footer() {
  return (
    <FooterWrapper className="footer-wrapper">
      <Col1>
        <ColumnTitle>Product</ColumnTitle>
        <ColumnContentsWrapper>
          <ColumnContentLink to="/product#inquiries-or-leads">
            Inquiries or leads
          </ColumnContentLink>
          <ColumnContentLink to="/product#meetings">Meetings</ColumnContentLink>
          <ColumnContentLink to="/product#contracts">
            Contracts
          </ColumnContentLink>
          <ColumnContentLink to="/product#invoice">Invoice</ColumnContentLink>
          <ColumnContentLink to="/product#milestone-and-progress">
            Milestone and progress
          </ColumnContentLink>
          <ColumnContentLink to="/product#deliverables">
            Deliverables
          </ColumnContentLink>
          <ColumnContentLink to="/product#feedback">Feedback</ColumnContentLink>
          <ColumnContentLink to="/product#notification">
            Notification
          </ColumnContentLink>
        </ColumnContentsWrapper>
      </Col1>
      <Col2>
        <ColumnTitle>Links</ColumnTitle>
        <ColumnContentsWrapper>
          <ColumnContentLink to="/signin">Sign in</ColumnContentLink>
          <FooterLink
            rel="noreferrer"
            target="_blank"
            href="http://help.yess.io/"
          >
            Help Center
          </FooterLink>
          <FooterLink
            rel="noreferrer"
            target="_blank"
            href="https://feedback.yess.io/roadmap"
          >
            Product Roadmap
          </FooterLink>
        </ColumnContentsWrapper>
      </Col2>
      <Col3>
        <ColumnTitle>Company</ColumnTitle>
        <ColumnContentsWrapper>
          <ColumnContentLink to="/about">About</ColumnContentLink>
          <FooterLink
            rel="noreferrer"
            target="_blank"
            href="https://yess.io/privacy"
          >
            Privacy policy
          </FooterLink>
        </ColumnContentsWrapper>
      </Col3>
      <Col4>
        <ColumnTitle>Follow us</ColumnTitle>
        <ColumnContentsWrapper>
          <SNSIconsWrapper>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.facebook.com/Yess-106632958401382"
            >
              <SvgFacebook />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://twitter.com/Yess_io"
            >
              <SvgTwitter />
            </a>
          </SNSIconsWrapper>
        </ColumnContentsWrapper>
      </Col4>
      <Logo>
        <LogoWrapper>
          <NameLogo />
        </LogoWrapper>
        <CopyrightText>
          © Copyright 2022 Additor Inc.
          <br />
          All rights reserved.
        </CopyrightText>
      </Logo>
    </FooterWrapper>
  );
}
